import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ShareModule } from './share/share.module';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { StorageServiceModule } from 'angular-webstorage-service';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LoginComponent } from './login/login.component';
import { AppRoutingModule } from './app.routing.module';
import { AppBootstrapModule } from './app.bootstrap.module';
import { AuthService } from './services/auth.service';
import { SessionsService } from './services/sessions.service';
import { DropdownModule } from 'primeng/dropdown';
import { AuthInterceptor } from './services/auth.interceptor';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { MensagemService } from './api-service/mensagem.service';
import { SortByPipe } from './share/sort-by.pipe';
import { TipoRegiao } from './share/tipo-regiao.pipe';
import { RelatorioPipe } from './share/relatorio.pipe';
import { CountPipe } from './share/count.pipe';
import { MoedaLocalPipe } from './moeda-local.pipe';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { SomaPipe } from './share/soma.pipe';
import { SafePipeModule } from 'safe-pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { AlertaComponent } from './components/alerta/alerta.component';
import { AlertaModule } from './components/alerta/alerta.module';
import { TabsComponent } from './components/tabs/tabs/tabs.component';
import { TabBodyComponent } from './components/tabs/tab-body/tab-body.component';
import { TabItemComponent } from './components/tabs/tab-item/tab-item.component';
import { TabLabelComponent } from './components/tabs/tab-label/tab-label.component';
import { AlertifyService } from './api-service/alertify.service';
import { NgxCurrencyModule } from 'ngx-currency';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { AgmCoreModule } from '@agm/core';
import { NgxColorsModule } from 'ngx-colors';
import { ModalNotificacoesComponent } from './components/modal-notificacoes/modal-notificacoes.component';
import { ToastrModule } from 'ngx-toastr';
import { SeletorAcessoRootComponent } from './inicio/seletor-acesso-root/seletor-acesso-root.component';
import { RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LgpdMaskPipe } from './share/lgpd-mask.pipe';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorIntlService } from './services/paginator-intl.service';

registerLocaleData(localePt);

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    LoginComponent,
    SortByPipe,
    TipoRegiao,
    TabsComponent,
    TabBodyComponent,
    TabItemComponent,
    TabLabelComponent,
    AlertaComponent,
    ModalNotificacoesComponent,
    SeletorAcessoRootComponent,
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    StorageServiceModule,
    AppRoutingModule,
    AppBootstrapModule,
    NgxPaginationModule,
    DropdownModule,
    AlertaModule,
    TabsModule.forRoot(),
    SafePipeModule,
    NgxCurrencyModule,
    NgxMaskModule.forRoot(maskConfig),
    ModalModule.forRoot(),
    NgxDropzoneModule,
    NgxColorsModule,
    ShareModule,
    NgbModule,
    RouterModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBYsMO6KnpXrl4d0Vg9HOC90ZmHKoh-LWw',
      libraries: ['places'],
    }),
    ToastrModule.forRoot({
      enableHtml: true,
      positionClass: 'toast-bottom-right',
      progressBar: true,
    }),
  ],
  providers: [
    BsModalService,
    AuthService,
    AuthGuard,
    { provide: MatPaginatorIntl, useClass: PaginatorIntlService },
    SessionsService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    MensagemService,
    AlertifyService,
    SortByPipe,
    RelatorioPipe,
    CountPipe,
    MoedaLocalPipe,
    LgpdMaskPipe,
    SomaPipe,
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR',
    },
  ],
  entryComponents: [ModalNotificacoesComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
